function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import LocalStorageAdapter from "./local_storage_adapter";
import utils from "../utils"; // # A parent class Adapter for using the Alephbet backend API.
// # uses fetch to send data with keepalive. Falls back on plain js xhr
// # params:
// # - url: track URL to post events to
// # - namepsace (optional): allows setting different environments etc
// # - storage (optional): storage adapter for the queue

var AlephbetAdapter = /*#__PURE__*/function () {
  function AlephbetAdapter(url) {
    var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "alephbet";
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : LocalStorageAdapter;

    _classCallCheck(this, AlephbetAdapter);

    _defineProperty(this, "queue_name", "_alephbet_queue");

    this._storage = storage;
    this.url = url;
    this.namespace = namespace;
    this._queue = JSON.parse(this._storage.get(this.queue_name) || "[]");

    this._flush();
  }

  _createClass(AlephbetAdapter, [{
    key: "_remove_quuid",
    value: function _remove_quuid(quuid) {
      var _this = this;

      return function (err, _res) {
        if (err) return;
        utils.remove(_this._queue, function (el) {
          return el.properties._quuid === quuid;
        });

        _this._storage.set(_this.queue_name, JSON.stringify(_this._queue));
      };
    }
  }, {
    key: "_merge_url_data",
    value: function _merge_url_data(url, data) {
      var params = [];

      for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        params.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(data[key])));
      }

      params = params.join("&").replace(/%20/g, "+");
      return "".concat(url, "?").concat(params);
    }
  }, {
    key: "_fetch_get",
    value: function _fetch_get(url, data, callback) {
      utils.log("send request using fetch", {
        url: url,
        data: data
      });
      return window.fetch(this._merge_url_data(url, data), {
        method: "GET",
        keepalive: true
      }).then(function (result) {
        if (result.status === 200) {
          callback();
        }
      });
    }
  }, {
    key: "_plain_js_get",
    value: function _plain_js_get(url, data, callback) {
      utils.log("fallback on plain js xhr", {
        url: url,
        data: data
      });
      var xhr = new XMLHttpRequest();
      xhr.open("GET", this._merge_url_data(url, data));

      xhr.onload = function () {
        if (xhr.status === 200) callback();
      };

      return xhr.send();
    }
  }, {
    key: "_ajax_get",
    value: function _ajax_get(url, data, callback) {
      if (window.fetch) {
        return this._fetch_get(url, data, callback);
      }

      return this._plain_js_get(url, data, callback);
    }
  }, {
    key: "_flush",
    value: function _flush() {
      var _iterator = _createForOfIteratorHelper(this._queue),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          var callback = this._remove_quuid(item.properties._quuid);

          this._ajax_get(this.url, utils.omit(item.properties, "_quuid"), callback);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_user_uuid",
    value: function _user_uuid(experiment, goal) {
      if (!experiment.user_id) return utils.uuid(); // if goal is not unique, we track it every time. return a new random uuid

      if (!goal.unique) return utils.uuid(); // for a given user id, namespace, goal and experiment, the uuid will always be the same
      // this avoids counting goals twice for the same user across different devices

      return utils.sha1("".concat(this.namespace, ".").concat(experiment.name, ".").concat(goal.name, ".").concat(experiment.user_id));
    }
  }, {
    key: "_track",
    value: function _track(experiment, variant, goal) {
      utils.log("Persistent Queue track", {
        namespace: this.namespace,
        experiment: experiment.name,
        variant: variant,
        goal: goal.name
      });
      if (this._queue.length > 100) this._queue.shift();

      this._queue.push({
        properties: {
          experiment: experiment.name,
          _quuid: utils.uuid(),
          // queue uuid (used only internally)
          uuid: this._user_uuid(experiment, goal),
          variant: variant,
          event: goal.name,
          namespace: this.namespace
        }
      });

      this._storage.set(this.queue_name, JSON.stringify(this._queue));

      this._flush();
    }
  }, {
    key: "experiment_start",
    value: function experiment_start(experiment, variant) {
      this._track(experiment, variant, {
        name: "participate",
        unique: true
      });
    }
  }, {
    key: "goal_complete",
    value: function goal_complete(experiment, variant, goal_name, props) {
      this._track(experiment, variant, utils.defaults({
        name: goal_name
      }, props));
    }
  }]);

  return AlephbetAdapter;
}();

export default AlephbetAdapter;